import React, { useEffect, useState } from 'react';
import { Button, Loader, Icon } from 'semantic-ui-react';
import _ from 'lodash';
import { post } from '../../../util/api';

// setOptions ile yapılan değişiklikler (maytap.product_option_log). "Geri al" o kayıttaki alanları önceki değerine döndürür.
export default function History({ product, onSaved }) {
	const [list, setList] = useState(null);
	const [error, setError] = useState(null);
	const [open, setOpen] = useState(null);
	const [reverting, setReverting] = useState(null);

	async function load() {
		try {
			let res = await post('/dahi/message/admin/optionLogs', { token: product.token });
			if (!res.data.success) throw new Error(res.data.error);
			setList(res.data.list);
		} catch (err) {
			setError(err.message);
		}
	}

	useEffect(() => {
		load();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [product.token]);

	async function revert(log) {
		let paths = _.keys(log.before);
		if (!window.confirm(paths.join(', ') + ' önceki değerine dönsün mü?')) return;
		setReverting(log._id);
		try {
			let set = {};
			let unset = [];
			_.each(log.before, (v, k) => {
				if (v === undefined || v === null) unset.push(k);
				else set[k] = v;
			});
			// before'da hiç olmayan alanlar (yeni eklenmiş) JSON'da düşer: onları da kaldır
			_.each(_.keys(log.set).concat(log.unset || []), (k) => {
				if (!_.has(log.before, k) && unset.indexOf(k) === -1 && !_.has(set, k)) unset.push(k);
			});
			let res = await post('/dahi/message/admin/setOptions', { token: product.token, set, unset });
			if (!res.data.success) throw new Error(res.data.error);
			onSaved(res.data.result);
			await load();
		} catch (err) {
			setError(err.message);
		}
		setReverting(null);
	}

	if (!list && !error) return <Loader active inline="centered" />;

	return (
		<div>
			{error ? <div className="yta-warn-list">{error}</div> : null}
			{list && !list.length ? (
				<div className="yta-card">
					<div className="yta-empty">
						<Icon name="history" size="big" />
						<div style={{ marginTop: 8 }}>Bu hesapta panelden yapılmış değişiklik yok.</div>
					</div>
				</div>
			) : null}
			{_.map(list, (log) => {
				let paths = _.keys(log.set).concat(_.map(log.unset, (k) => k + ' (silindi)'));
				return (
					<div key={log._id} className="yta-card">
						<div className="yta-card-head" style={{ fontWeight: 400 }}>
							<Icon name="history" color="grey" />
							<div style={{ flex: 1, minWidth: 0 }}>
								<b>{log.email || log.uid}</b>
								<span className="yta-muted"> · {new Date(log.time).toLocaleString()}</span>
								<div className="yta-field-key" style={{ marginTop: 3 }}>
									{_.truncate(paths.join(', '), { length: 220 })}
								</div>
							</div>
							<Button size="mini" basic content={open === log._id ? 'Gizle' : 'Detay'} onClick={() => setOpen(open === log._id ? null : log._id)} />
							<Button size="mini" basic color="orange" icon="undo" content="Geri al" loading={reverting === log._id} onClick={() => revert(log)} />
						</div>
						{open === log._id ? (
							<div className="yta-card-body yta-cols">
								<div>
									<div className="yta-col-title">Önce</div>
									<pre className="yta-mono" style={{ maxHeight: 420, overflow: 'auto', margin: 0 }}>
										{JSON.stringify(log.before, null, 2)}
									</pre>
								</div>
								<div>
									<div className="yta-col-title">Sonra</div>
									<pre className="yta-mono" style={{ maxHeight: 420, overflow: 'auto', margin: 0 }}>
										{JSON.stringify(_.assign({}, log.set, _.zipObject(log.unset || [], _.map(log.unset, () => '(silindi)'))), null, 2)}
									</pre>
								</div>
							</div>
						) : null}
					</div>
				);
			})}
		</div>
	);
}
